import { useEffect, useState } from "react";
import { cartonField } from "./catonFormField";
import { Button, Switch, FormControlLabel } from "@mui/material";
import { toast } from "../../../components/AppToast";
import { height } from "@mui/system";
import { getPackingSizeData } from "../../../services/packing/packing";

export default function CreatePackagingMaster({ initialValues, onCancel, onSubmit, viewOnly, isEdit }) {
  const [exclusionOptions, setExclusionOptions] = useState(
    cartonField.find(f => f.name === "exclusions")?.options || []
  );

  const [packageSize, setPackageSize] = useState();
  const [formData, setFormData] = useState({
    pkgId: '',
    pkgSize: '',
    length: '',
    width: '',
    height: '',
    um: 'cm',
    volCapacity: '',
    weightCapacity: '',
    exclusions: 'None'
  });


  const handleChange = (name, value) => {
    setFormData(prev => ({
      ...formData,
      [name]: value
    }));

    if (name === "pkgType") {
      setPackageSize(null);
      setFormData(prev => ({
        ...prev,
        pkgSize: ''
      }))
      if (value != "") {
        applyPackageRules(value);
      }
    }

  };

  const getPackingSize = async (value) => {
    try {
      const response = await getPackingSizeData({ pkgType: value });
      if (response.length > 0) {
        setPackageSize(response[0].sizes)
      }

    } catch (err) {
      if (err?.message) {
        toast.error(err.message);
      } else {
        toast.error("Something went wrong");
      }
    }
  };


  const applyPackageRules = async (value) => {
    await getPackingSize(value);
    if (value === "Poly Mailer" || value === "Envelope") {
      setExclusionOptions([
        { label: "Fragile", value: "Fragile" },
        { label: "Liquids", value: "Liquids" }
      ]);

      if (value === "Box" || value === "Carton") {
        setExclusionOptions([{ label: "None", value: "None" }]);
      }

      if (value === "Bubble Mailer") {
        setExclusionOptions([{ label: "Liquids", value: "Liquids" }]);
      }
    };
  }


  const submit = async (e) => {
    e.preventDefault();

    try {
      const { length, width, height, um, ...rest } = formData;
      let dimensionss = length + '*' + width + '*' + height + '(' + um + ')';
      const finalData = { ...formData, dimensions: dimensionss };

      if (isEdit) {
        await onSubmit(finalData, initialValues._id);
      } else {
        await onSubmit(finalData);
      }
    } catch (err) {
      if (err?.data?.message) {
        toast.error(err.data.message);
      } else {
        toast.error("Error saving carton");
      }
    }
  };


  useEffect(() => {
    if (viewOnly || isEdit) {
      const { dimensions, ...rest } = initialValues;
      let splitData = dimensions.split('*');
      let lengthh = splitData[0];
      let widthh = splitData[1];
      let heightt = splitData[2].replace(/\(.*\)/, '');

      applyPackageRules(initialValues.pkgType);
      setFormData({ ...rest, length: Number(lengthh), width: Number(widthh), height: Number(heightt), um: 'cm' });
    }
  }, [viewOnly, isEdit, initialValues])

  return (
    <form>
      <div className="d-flex flex-wrap gap-3">

        {cartonField.map((field) => (
          <div
            key={field.name}
            className="mb-1"
            style={{ flex: `0 0 ${field.width || "15%"}` }}

          >
            <label className="form-label">
              {field.label}
              {field.required && <span className="text-danger"> *</span>}
            </label>

            {field.type === "select" ? (
              <select
                className="form-select"
                value={formData[field.name] || ""}
                onChange={(e) => handleChange(field.name, e.target.value)}
                disabled={viewOnly}
              >
                <option value="" style={{ fontSize: '12px' }}>Select</option>

                {field.name === 'pkgType' && field.option?.map((opt) => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}

                {field.name === 'pkgSize' && packageSize?.map((opt) => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}

                {field.name === 'exclusions' && exclusionOptions?.map((opt) => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}

                {field.name === 'um' && field.options?.map((opt) => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </select>
            ) : field.type === "dimension" ? (
              <div className="d-flex align-items-center gap-1">
                <input
                  type="text"
                  className="form-control"
                  style={{ width: "50px" }}
                  value={formData.length || ""}
                  onChange={(e) => handleChange("length", e.target.value)}
                  readOnly={viewOnly}
                />
                <span>*</span>
                <input
                  type="text"
                  className="form-control"
                  style={{ width: "50px" }}
                  value={formData.width || ""}
                  onChange={(e) => handleChange("width", e.target.value)}
                  readOnly={viewOnly}
                />
                <span>*</span>
                <input
                  type="text"
                  className="form-control"
                  style={{ width: "50px" }}
                  value={formData.height || ""}
                  onChange={(e) => handleChange("height", e.target.value)}
                  readOnly={viewOnly}
                />
              </div>
            ) : (
              <input
                type={field.type || "text"}
                className="form-control"
                value={formData[field.name] || ""}
                onChange={(e) => handleChange(field.name, e.target.value)}
                readOnly={viewOnly}
              />
            )}

          </div>
        ))}

      </div>

      <div className="d-flex justify-content-center gap-2 mt-3">
        <button className="btn btn-secondary" onClick={onCancel}>
          Back
        </button>
        <button
          className="btn btn-primary"
          onClick={submit}

          style={{ display: !viewOnly && !isEdit ? 'inline-flex' : 'none' }}
        >
          Save
        </button>


        <button className="btn btn-primary"
          onClick={submit}
          style={{ display: isEdit && !viewOnly ? 'inline-flex' : 'none' }}
        >
          Update
        </button>
      </div>

    </form>
  );
};


